<template>
  <div class="m-message">
    <el-avatar shape="square" @click.native="link('user', { id: info.id })" icon="el-icon-user" :src="info.avatar"></el-avatar>
    <div class="info">
      <p style="font-size: 12px; color: #000;width: auto">
        <span @click="link('user', { id: info.id })">{{ info.company }}</span>
      </p>
      <p style="font-size: 12px; color: #999;width: auto">
        <span @click="link('user', { id: info.id })">{{ info.isAnonymous ? "【匿名】" : "" }} {{ info.name }}</span>
      </p>
      <div class="pre-box">
        <span v-for="item in info.ats" :key="item.at" class="at-btn" @click.stop="link('user', { id: item.at })">@{{ item.atName }}</span>
        <pre v-html="text"></pre>
        <template v-if="info.msgType === 6 && info.aiResult">
          <p v-for="(item, index) in info.aiResult" :key="index">
            <span class="at-btn" @click.stop="link('company', { id: item.id, name: item.name })">{{ item.name }} </span>
          </p>
        </template>
      </div>
      <div class="image-box" :style="{ height: fold ? '60px' : 'auto', overflow: 'hidden' }" v-if="info.imgs">
        <div class="image" v-for="(item, index) in info.imgs" :key="index">
          <div v-if="index === 3 && info.imgs.length > 4 && fold" @click="fold = false" class="more-btn">
            <i class="el-icon-more"></i>
            共{{ info.imgs.length }}个
          </div>
          <el-image :src="item" :preview-src-list="info.imgs">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>
      </div>
      <div class="tool-box">
        <template v-if="info.msgType !== 3">
          <svg-icon @click.native="clickBtnHandle('reply')" v-if="info.tags" name="comment"></svg-icon>
          <svg-icon name="at" @click.native="clickBtnHandle('at')"></svg-icon>
          <span v-if="info.likeCount" class="like-count">{{ info.likeCount }}</span>
          <report-btn :info="info"></report-btn>
        </template>
        <span v-if="info.tags && showTags" class="link" @click="link('detail', { id: info.msgId })">{{ info.tags }}详情 </span>
        <span v-if="rewardInfo && rewardInfo.id === userId" class="link" @click="giveRewardHandle(info)">打赏</span>
        <template v-if="info.msgType !== 3 && info.id === userId && info.tags">
          <quick-btn @click="quickClickHandle">
            <svg-icon name="morevert" title="更多" slot="reference" style="fill: #ccc;margin-top: 3px; transform: rotate(90deg);"></svg-icon>
          </quick-btn>
        </template>
      </div>
    </div>
    <div class="right">
      <div class="reward-box">
        <span v-if="info.hasOwnProperty('rewardAmount')">
          <svg-icon name="money"></svg-icon>
          {{ (info.rewardAmount * 100 - info.rewardAmountOut * 100) / 100 }}</span
        >
        <span v-else-if="info.hasOwnProperty('getRewardAmount')">
          <i class="el-icon-coin"></i>
          {{ info.getRewardAmount }}</span
        >
      </div>
      <span v-if="info.isTop" class="top" title="置顶">
        <i class="el-icon-upload2"></i>
      </span>
      <span style="color: #999"> {{ info.time }}</span>
    </div>
    <el-dialog :title="quickType.label" v-if="visible" :visible.sync="visible" width="95%">
      <top-dialog v-if="quickType.name === 'top'" :info="info" :has-join="isTop" @success="info.isTop = true" :visible.sync="visible"></top-dialog>

      <broad-dialog v-if="quickType.name === 'broadcast'" :visible.sync="visible" :has-join="info.bcStatus === 1" :info="info"></broad-dialog>

      <red-dialog v-if="quickType.name === 'red'" :visible.sync="visible" :info="info"></red-dialog>

      <reward-dialog v-if="quickType.name === 'reward'" :visible.sync="visible" :info="info"> </reward-dialog>
    </el-dialog>
    <el-dialog v-if="giveRewardVisible" width="95%" title="打赏" :visible.sync="giveRewardVisible">
      <give-reward :visible.sync="giveRewardVisible" :give-info="giveInfo" :reward-info="rewardInfo"></give-reward>
    </el-dialog>
  </div>
</template>
<script>
import Tags from "./tags";
import Bus from "@/components/Bus";
import ReportBtn from "./ReportBtn";
import QuickBtn from "@/components/QuickBtn";
import TopDialog from "@/components/dialog/Topic";
import BroadDialog from "@/components/dialog/Broad";
import RedDialog from "@/components/dialog/Red";
import RewardDialog from "@/components/dialog/Reward";
import GiveReward from "@/components/dialog/GiveReward";
export default {
  data() {
    return {
      visible: false,
      reportDetail: "",
      giveRewardVisible: false,
      giveInfo: {},
      tipTxt: "",
      fold: true,
      quickType: {}
    };
  },
  props: {
    info: {},
    keyword: String,
    hideBtns: {
      type: Array,
      default() {
        return [];
      }
    },
    isTop: {
      default() {
        return false;
      }
    },
    showTags: {
      type: Boolean,
      default: true
    },
    rewardInfo: {
      type: Object,
      default() {
        return null;
      }
    },
    types: {
      type: Array,
      default() {
        return Tags;
      }
    }
  },
  components: {
    ReportBtn,
    QuickBtn,
    TopDialog,
    BroadDialog,
    RedDialog,
    GiveReward,
    RewardDialog
  },
  computed: {
    likeList() {
      return this.$store.state.likeList;
    },
    userId() {
      return this.$store.state.userId;
    },
    text() {
      if (this.keyword) {
        const reg = new RegExp(this.keyword, "gi");
        return this.info.txt.replace(reg, `<a style="background: #ffe991; color: red;">${this.keyword}</a>`);
      } else {
        return this.info.txt;
      }
    }
  },
  methods: {
    giveRewardHandle(info) {
      this.giveRewardVisible = true;
      this.giveInfo = info;
    },
    quickClickHandle(event) {
      this.quickType = event;
      this.visible = true;
    },
    link(path, query) {
      if (this.info.msgType === 3 && path === "detail") {
        Bus.$emit("openRedEnvelope", this.info);
        return true;
      }
      if (path === "user" && this.info.isAnonymous) {
        return false;
      }
      if ((path === "detail" || path === "user") && !query.id) {
        return false;
      }
      this.$router.push({ path, query });
    },
    async clickBtnHandle(type) {
      if (type === "like") {
        const result = await this.$store.dispatch("like", this.info.msgId);
        if (result) {
          this.info.likeCount += 1;
        }
      }
      this.$emit("click-btn", { type, info: this.info });
    }
  }
};
</script>
<style lang="scss">
.m-message {
  $avatarSize: 38px;
  position: relative;
  display: flex;
  width: 100%;
  .like-count {
    font-size: 12px;
    margin-left: -5px;
    color: #ccc;
  }
  .pre-box {
    font-size: 14px;
    padding: 10px 0 8px 0;
    .el-button {
      padding: 0;
      margin: 0;
      margin-right: 5px;
    }
  }
  .el-image {
    margin-right: 5px;
    width: 60px;
    height: 60px;
  }
  .el-avatar {
    margin-top: 5px;
    width: $avatarSize;
    height: $avatarSize;
    margin-right: 10px;
    flex-shrink: 0;
  }
  .name,
  .company {
    display: inline-block;
    cursor: pointer;
  }
  .info {
    margin-top: 5px;
    display: flex;
    flex-direction: column;
    width: 100%;
    font-size: 12px;
    padding-bottom: 10px;
    .image-box {
      display: flex;
      flex-wrap: wrap;
      width: 300px;
      margin: -5px 0px 5px -5px;
      .image {
        display: inline-block;
        position: relative;
        width: 60px;
        height: 60px;
        margin: 5px;
      }
      .more-btn {
        position: absolute;
        top: 0;
        z-index: 10;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background-color: black;
        color: white;
        opacity: 0.5;
      }
    }
  }
  .tool-box {
    height: 14px;
    display: flex;
    align-items: center;
    > * {
      margin-right: 5px;
    }
    svg {
      cursor: pointer;
      font-size: 14px;
      fill: #b3c2df;
    }
    .m-report-btn {
      height: 14px;
    }
    .link {
      cursor: pointer;
      font-size: 12px;
      color: #b3c2df;
    }
  }
  .expand-btn-box {
    display: flex;
    span {
      cursor: pointer;
      margin-right: 10px;
      color: #ccc;
    }
    .is-top {
      color: #409eff;
      &:before {
        content: "已";
      }
    }
  }
  > .right {
    position: absolute;
    height: 100%;
    right: 0px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    white-space: nowrap;
    font-size: 12px;
    color: #ccc;
    text-align: center;
    .el-tag {
      width: 100%;
    }
    .reward-box {
      position: absolute;
      top: 6px;
      span {
        color: #b3c2df;
      }
    }
    .top {
      position: absolute;
      display: flex;
      width: 32px;
      height: 32px;
      right: 0;
      top: 0;
      i {
        position: absolute;
        right: 2px;
        top: 2px;
        font-size: 14px;
        color: #fff;
      }
      &:before {
        position: absolute;
        z-index: -1;
        right: 0;
        content: "";
        display: block;
        border: 16px solid transparent;
        border-top-color: #d32f2f !important;
        border-right-color: #d32f2f !important;
      }
    }
  }
}
</style>
